import { render, staticRenderFns } from "./brands-view.vue?vue&type=template&id=1810d33e&scoped=true&lang=pug"
import script from "./brands-view.js?vue&type=script&lang=js&external"
export * from "./brands-view.js?vue&type=script&lang=js&external"
import style0 from "./brands-view.vue?vue&type=style&index=0&id=1810d33e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1810d33e",
  null
  
)

export default component.exports